import React from 'react';
import LoadingButton from '../../components/LoadingButton';
import { View } from 'react-native';

interface CreateUpdateProps {
  isUpdating: boolean;
  isEditing: boolean;
  onCreate: () => Promise<void>;
  onUpdate: () => Promise<void>;
}

const CreateUpdateButtons: React.FC<CreateUpdateProps> = ({ isUpdating, isEditing, onCreate, onUpdate }) => (
  <View style={{ marginVertical: 16 }}>
    {isEditing ? (
      <LoadingButton 
        onPress={onUpdate} 
        disabled={isUpdating} 
        backgroundColor="#39BEB7"
      >
        Update Charger
      </LoadingButton>
    ) : (
      <LoadingButton 
        onPress={onCreate} 
        disabled={isUpdating} 
        backgroundColor="#39BEB7"
      >
        Create Charger
      </LoadingButton>
    )}
  </View>
);

export default CreateUpdateButtons;